module.exports = __webpack_public_path__ + "static/img/bj_coupon_Have received@3x.3f19f19.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bj_coupon_Have received@3x.png
// module id = Wt+p
// module chunks = 1